import React, { ReactNode } from 'react';

import productFormSchema, { ProductFormSchema } from 'core/schemas/productForm';
import { Form, FormSubmitHandler } from 'Elements/Form';

type Props = {
  onSubmit: FormSubmitHandler<ProductFormSchema>;
  product?: ProductFormSchema['product'];
  children: ReactNode;
  id?: number;
};

export default function ProductForm({
  onSubmit,
  product,
  children,
  id
}: Props) {
  return (
    <Form
      validationSchema={productFormSchema.meta({ productId: id })}
      onSubmit={onSubmit}
      initialValues={{ product }}
    >
      {children}
    </Form>
  );
}
